export default __webpack_public_path__ + "static/5-da246d970b39aa41bcf3ca98d4908a81.jpeg";